module.exports = __webpack_public_path__ + "img/chara2.9fa3801d.png";